import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { setPageMeta } from "../seo/setPageMeta";
import { RECOVERY_JOURNEY_STEPS } from "../data/recoveryJourney";

export default function RecoveryJourney() {
  useEffect(() => {
    setPageMeta({
      title: "Aletheia: Recovery Journey | Celebrate Recovery Independence KY",
      description:
        "Twelve original reflections on truth, honesty, and freedom for the road of recovery — read online or download the full devotional.",
      canonical: "https://www.crindependenceky.com/recovery-journey",
    });
  }, []);

  return (
    <section className="journey-article">
      <h2 className="page-title">Aletheia: Recovery Journey</h2>
      <p className="page-intro">
        Twelve reflections on truth, honesty, and freedom for the road of
        recovery, at whatever pace healing actually takes. Read any step
        below, or download the whole devotional to keep.
      </p>

      <div className="button-row">
        <a
          className="btn btn-primary"
          href="/downloads/aletheia-recovery-journey.pdf"
          download
        >
          Download the Full Devotional (PDF)
        </a>
      </div>

      <div className="journey-list">
        {RECOVERY_JOURNEY_STEPS.map((step, i) => (
          <Link
            key={step.title}
            to={`/recovery-journey/${i + 1}`}
            className="journey-list-item"
          >
            <span className="journey-word-chip">{step.lesson.word}</span>
            <span className="journey-list-title">
              Step {i + 1}: {step.title}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}
